import { BenchmarkStateTraitReason, TraitId } from '@cibo/core'
import { useTranslation } from 'react-i18next'

export const useReasonMessages = () => {
  const { t } = useTranslation('@cibo/ui/useReasonMessages')

  return {
    byReasonCode: ({
      reasonCode,
      traitId,
    }: {
      reasonCode: BenchmarkStateTraitReason
      traitId: TraitId
    }) => {
      return t(`reasonCode_${reasonCode}`, { traitName: t(`${traitId}`, { ns: 'traits' }) })
    },
  }
}
